import { useMemo } from 'react';

import { DetailsType } from 'store/details/actions.types';
import { RBProgram } from 'store/railsBuilder/reducer.types';
import { RecordingItem } from 'store/recordings/reducer.types';

import { isRecordingItem } from 'utils/recordings';

/**
 * Define based on what "content image id" the image url would be built.
 * If Details page was opened and data retrieved based on the "id" - use "id" in the image url.
 * If Details page was opened and data retrieved based on the "contentId" - use "contentId" in the image url.
 * @param details
 */
function useDetailsImageId(details: DetailsType) {
    return useMemo(() => {
        if (isRecordingItem(details)) {
            return (details as RecordingItem).contentId;
        }

        if (details?.id) {
            return details.id;
        }

        if ((details as RBProgram)?.contentRef) {
            return (details as RBProgram)?.contentRef || '';
        }

        return '';
    }, [details]);
}

export default useDetailsImageId;
